import {
  CHANGE_ALLOWED_DOMAINS,
  CHANGE_DMARC_FOR_PARTNERS,
  CHANGE_ENFORCE_MAILBOXES_LIMIT,
  CHANGE_EXPIRATION_DATE,
  CHANGE_MAILBOX_LIMIT,
  CHANGE_PLAN,
  CHANGE_SILENT_MODE_STATUS,
  CHANGE_TRIAL_EXPIRATION,
  CHANGE_TRIAL_PLAN,
  EDIT_TENANT_APPLY_ASYNC,
  FETCH_TENANT_DATA,
  TOGGLE_ADDON,
  TOGGLE_AUTOPILOT,
} from './constants'

const fetchTenantData = (tenantId) => ({
  type: FETCH_TENANT_DATA.INITIATE,
  payload: { tenantId },
})
const fetchTenantDataCancel = () => ({
  type: FETCH_TENANT_DATA.CANCEL,
})
export const fetchTenantDataSuccess = (data) => ({
  type: FETCH_TENANT_DATA.SUCCESS,
  payload: { data },
})
export const fetchTenantDataError = (error) => ({
  type: FETCH_TENANT_DATA.ERROR,
  error,
})

const editTenantApply = (tenantId, tenantName) => ({
  type: EDIT_TENANT_APPLY_ASYNC.INITIATE,
  payload: { tenantId, tenantName },
})
export const editTenantApplySuccess = (data) => ({
  type: EDIT_TENANT_APPLY_ASYNC.SUCCESS,
  payload: { data },
})
export const editTenantApplyError = (error) => ({
  type: EDIT_TENANT_APPLY_ASYNC.ERROR,
  error,
})
const editTenantApplyCancel = () => ({
  type: EDIT_TENANT_APPLY_ASYNC.CANCEL,
})

const changePlan = (value) => ({ type: CHANGE_PLAN, payload: { value } })
const changeMailboxLimit = (value) => ({ type: CHANGE_MAILBOX_LIMIT, payload: { value } })
const changeExpirationDate = (value) => ({ type: CHANGE_EXPIRATION_DATE, payload: { value } })
const changeTrialPlan = (value) => ({ type: CHANGE_TRIAL_PLAN, payload: { value } })
const changeTrialExpiration = (value) => ({
  type: CHANGE_TRIAL_EXPIRATION,
  payload: { value },
})
const changeSilentModeStatus = (value) => ({ type: CHANGE_SILENT_MODE_STATUS, payload: { value } })
const changeAllowedDomains = (value) => ({ type: CHANGE_ALLOWED_DOMAINS, payload: { value } })
const changeMailboxesEnforceLimit = (value) => ({
  type: CHANGE_ENFORCE_MAILBOXES_LIMIT,
  payload: { value },
})
const changeDmarcForPartners = (value) => ({
  type: CHANGE_DMARC_FOR_PARTNERS,
  payload: { value },
})
const toggleAddon = (addonName) => ({ type: TOGGLE_ADDON, payload: { addonName } })
export const toggleAutopilot = () => ({ type: TOGGLE_AUTOPILOT })

export default {
  // to props
  fetchTenantData,
  fetchTenantDataCancel,
  editTenantApply,
  editTenantApplyCancel,
  changePlan,
  changeMailboxLimit,
  changeExpirationDate,
  changeTrialPlan,
  changeTrialExpiration,
  changeSilentModeStatus,
  changeAllowedDomains,
  changeMailboxesEnforceLimit,
  changeDmarcForPartners,
  toggleAddon,
}
